import { createMuiTheme } from '@material-ui/core'
import { themeConstructor } from './themeConstructor'
import { redPalette as palette } from '../palettes'

export const redTheme = createMuiTheme({
  ...themeConstructor(palette), // default theme
  palette, // override color schema
})
